import React from 'react';
import PropTypes from 'prop-types';

import { getTravelType } from './TravelTypes';
import Address from '../../../../common/ui/Address';
import { EntityName, EntityType, EntityDesciption } from '../EditPageCommon/EditPageSortableList';

const TravelDetails = entity => {
  const travel = entity || {};
  const {
    type,
    name,
    code,
    note,
    address_1: address1,
    address2,
    city,
    state_province: stateProvince,
    postal_code: postalCode,
    country_code: countryCode,
  } = travel;
  const travelType = getTravelType(type);

  return (
    <>
      <EntityType type={travelType} />
      <EntityName name={name} />
      {address1 && (
        <EntityDesciption>
          <Address
            address1={address1}
            address2={address2}
            city={city}
            state={stateProvince}
            zip={postalCode}
            countryCode={countryCode}
            singleLine
          />
        </EntityDesciption>
      )}
      {code && <EntityDesciption addClass="text-primary">Discount Code - {code}</EntityDesciption>}
      {note && <EntityDesciption description={note} />}
    </>
  );
};

TravelDetails.propTypes = {
  entity: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string,
    note: PropTypes.string,
    address_1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state_province: PropTypes.string,
    postal_code: PropTypes.string,
    country_code: PropTypes.string,
  }),
};

export default TravelDetails;
